export default "__VITE_ASSET__fSzPIfSp__"